/**
 * Determines if a selection is valid
 *
 * @param selectedItems - Array of currently selected items
 * @param initialItems - Array of initially selected items
 * @returns true if selection contains at least one item and is different from the initial selection, false otherwise
 */
export const isSelectionValid: {
  (selectedItems: string[], initialItems?: string[]): boolean;
  <T>(selectedItems: T[], initialItems: T[] | undefined, transformFn: (item: T) => string): boolean;
} = <T>(selectedItems: T[], initialItems?: T[], transformFn?: (item: T) => string): boolean => {
  if (selectedItems.length === 0) return false;
  if (!initialItems) return true;

  const toComparableValues = (items: T[]): string[] => {
    const values = transformFn ? items.map(transformFn) : (items as string[]);
    return [...new Set(values)];
  };

  const initialValues = toComparableValues(initialItems);
  const selectedValues = toComparableValues(selectedItems);

  if (selectedValues.length !== initialValues.length) return true;
  return !selectedValues.every((value) => initialValues.includes(value));
};
